$(function() {

	var $loader = $('#loader');

	window.toggleLoader = function(show, message) {
		$loader.find('.message').html(message ? message : '');
		$loader[show ? 'addClass' : 'removeClass']('visible');
	}

});